import React from "react"

import { UserInfo } from "shared/types/UserInfo"
import { NeoletterUserProfile } from "shared/types/__generated__/graphql"

import { useAppSidebarViewModel } from "./model/useAppSidebarViewModel"
import { AppSidebarView } from "./ui/AppSidebarView"

export { AppSidebarConnector } from "./AppSidebarConnector"

export interface AppSidebarModel {
  menuLinks: React.ReactNode
  menuLinksSecondary: React.ReactNode
  menuLinksTertiary: React.ReactNode
  userDetailsSlot: React.ReactNode

  userInfo: NeoletterUserProfile | UserInfo | null | undefined
  isLoadingUserInfo: boolean
  onLogin: () => void
  onLogout: () => void

  isOpen: boolean
  isExpanded: boolean
  inert: boolean

  onOpen: () => void
  onClose: () => void

  onToggleOpen: () => void
  onToggleExpanded: () => void
}

export interface AppSidebarProps extends AppSidebarModel {}

export function AppSidebar(props: AppSidebarProps) {
  return <AppSidebarView {...useAppSidebarViewModel(props)} />
}
